// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3eIkW","alert":"SettungsInbox_alert__2gJta"};